import React, { useEffect, useState } from 'react'
import Toasts from '../../Components/Toasts/Toasts'
import { ProfileApis } from '../../API/Login/ProfileApi'
import { Field, Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import { formatPhoneNumber } from '../../utils/GeneralUtils'
import { LoginApis } from '../../API/Login/LoginApi'
import ErrorHandle from '../../Components/ErrorHandle'
import { setEmailVerificationStatus, setFrProUser, setMobileVerificationStatus } from '../../store/reducers/Users/users'
import InputField from '../../Components/inputField'
import { FormHelperText, Typography } from '@mui/material'
import { CanadaStates, UsaStates } from '../../Data/states-cities'

const PersonalInfoUpdateScreen = (props) => {
  const navigate = useNavigate()
  const [toasts, setToasts] = useState(null)
  const emailRules = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
  const { frProUser, emailVerified, numberVerified } = useSelector((state) => state.Users);
  const dispatch = useDispatch()
  const [nativecountries, setNativecountries] = useState([])
  const [currentstates, setCurrentstates] = useState([])
  const [nativestates, setNativestates] = useState([])
  const [currentcountries, setCurrentcountries] = useState([])
  const [selectedNativeState, setSelectedNativeState] = useState('')
  const [selectedNativeCountry, setSelectedNativeCountry] = useState('')
  const [selectedCurrentState, setSelectedCurrentState] = useState('')
  const [selectedCurrentCountry, setSelectedCurrentCountry] = useState('')

  const handleMobileChecker = async (values) => {
    const obj = {
      mobileNumber:
        values?.mobileNumber?.length === 11 ||
          values?.mobileNumber?.length === 10
          ? formatPhoneNumber(values?.mobileNumber)
          : values?.mobileNumber,
      email: values?.email,
      fre8ProUserId: frProUser?.userId,
    }
    try {
      const res = await LoginApis.mobileNumberIsAvailable(obj)
      if (res?.data?.available) {
        return false
      }
      return true
    } catch (err) {
      console.log(err)
      let customMessage = 'Mobile availble API failed'
      let type = 'User Information'
      let color = 'red'
      ErrorHandle(err, setToasts, customMessage, type, color)
    }
  }

  const handleEmailChecker = async (values) => {
    const obj = {
      mobileNumber: values?.mobileNumber,
      email: values?.email,
      fre8ProUserId: frProUser?.userId,
    }
    // setFieldTouched('email', true, true)
    try {
      const res = await LoginApis.emailIsAvailable(obj)
      if (res?.data?.available) {
        return false
      }

      return true
    } catch (err) {
      console.log(err)
      let customMessage = 'Email availble API failed'
      let type = 'User Information'
      let color = 'red'
      ErrorHandle(err, setToasts, customMessage, type, color)
    }
  }

  const getStates = (countryName, typeofLoction) => {
    LoginApis.getStates(countryName)
      .then((res) => {
        if (typeofLoction === 'current') return setCurrentstates(res?.data)

        setNativestates(res?.data)
      })
      .catch((err) => {
        console.log(':VAlues from login', err)
        let customMessage = 'states failed'
        let type = 'User Information'
        let color = 'red'
        ErrorHandle(err, setToasts, customMessage, type, color)
      })
  }

  const handleCountryChange = (event, typeofLoction) => {
    const countryName = event?.currentTarget?.value
    if (typeofLoction === 'current') {
      const country = currentcountries?.find(
        (c) => c.countryName === countryName
      )
      console.log('handleCountryChange', country?.countryId)
      getStates(country?.countryId, typeofLoction)
      setSelectedCurrentCountry(country?.countryName)
      setSelectedCurrentState()
      return
    }

    const country = nativecountries?.find((c) => c.countryName === countryName)
    getStates(country?.countryId, typeofLoction)
    setSelectedNativeCountry(country?.countryName)
    setSelectedNativeState()
  }

  const handleStateChange = (event, typeofLoction) => {
    if (typeofLoction === 'current')
      return setSelectedCurrentState(event.target.value)
    setSelectedNativeState(event.target.value)
  }

  const getCountries = () => {
    LoginApis.getCountries()
      .then((res) => {
        setCurrentcountries(res?.data)
        setNativecountries(res?.data)
      })
      .catch((err) => {
        console.log(':VAlues from getcountries', err)
        let customMessage = 'countries failed'
        let type = 'User Information'
        let color = 'red'
        ErrorHandle(err, setToasts, customMessage, type, color)
      })
  }

  useEffect(() => {
    getCountries()

    // handleCountryChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      {/* <GetUserProfile /> */}
      <main className="main users chart-page h-100 ">
        <div className="container-fluid p-lg-4">
          <div className="personal-detais">
            <div className="form mt-4">
              <Formik
                initialValues={{
                  firstName:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.firstName || '',
                  lastName:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.lastName || '',
                  birthDate:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.birthDate || '',
                  birthday:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.birthday || '',
                  birthMonth:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.birthMonth || '',
                  birthYear:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.birthYear || '',
                  gender:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.gender || '',
                  relationshipStatus:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.relationshipStatus
                      ?.relationshipStatus || '',
                  mobileNumber:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.mobileNumber?.mobile || '',
                  secondaryMobileNumber:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.secondaryMobileNumber?.mobile || '',
                  email:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.email?.email || '',
                  secondaryEmail:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.secondaryEmail?.email || '',
                  currentLocationCountry:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.currentPlaceOfLiving?.country
                      ?.countryName || '',
                  currentLocationState:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.currentPlaceOfLiving?.state
                      ?.stateName || '',
                  currentLocationCity:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.currentPlaceOfLiving?.city?.cityName ||
                    '',
                  currentLocationZip:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.currentPlaceOfLiving?.zip || '',
                  nativeLocationCountry:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.nativePlace?.country?.countryName || '',
                  nativeLocationState:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.nativePlace?.state?.stateName || '',
                  nativeLocationCity:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.nativePlace?.city?.cityName || '',
                  nativeLocationZip:
                    frProUser?.updateProfileForm?.personalInfoForm
                      ?.nativePlace?.zip || '',
                }}
                validationSchema={Yup.object().shape({
                  firstName: Yup.string().required(
                    'Enter your first name'
                  ),
                  lastName: Yup.string().required(
                    'Enter your last name'
                  ),
                  birthday: Yup.string().required('date'),
                  birthMonth: Yup.string().required('month'),
                  birthYear: Yup.string().required(' year'),
                  gender:
                    Yup.string().required('Enter your gender'),
                  relationshipStatus: Yup.string().required(
                    'Enter your relationship status'
                  ),
                  mobileNumber: Yup.string()
                    .required(
                      'Invalid phone number format. Please provide phone number in this format: +1 (555) 000-0000'
                    )
                    .test(
                      'checkPhoneNumber2Exists',
                      'Mobile number already exists in the system.',
                      async function () {
                        let values = this.parent
                        const isAvailable =
                          await handleMobileChecker(values)

                        return isAvailable
                      }
                    ),
                  // secondaryMobileNumber: Yup.string(),
                  email: Yup.string()
                    .matches(
                      emailRules,
                      'Incorrect email format'
                    )
                    .required('Missing Information')
                    .test(
                      'checkEmailExists',
                      'This email already exists in the system.',
                      async function () {
                        let values = this.parent
                        const isAvailable =
                          await handleEmailChecker(values)

                        return isAvailable
                      }
                    ),
                  secondaryEmail: Yup.string(),
                  currentLocationCountry: Yup.string().required(
                    'Enter your current location country'
                  ),
                  currentLocationState: Yup.string().required(
                    'Enter your current location state'
                  ),
                  currentLocationCity: Yup.string().required(
                    'Enter your current location city'
                  ),
                  currentLocationZip: Yup.string().required(
                    'Enter your current location zip'
                  ),
                  nativeLocationCountry: Yup.string().required(
                    'Enter your native location country'
                  ),
                  nativeLocationState: Yup.string().required(
                    'Enter your native location state'
                  ),
                  nativeLocationCity: Yup.string().required(
                    'Enter your native location city'
                  ),
                  nativeLocationZip: Yup.string().required(
                    'Enter your native location zip'
                  ),
                })}
                onSubmit={(values) => {
                  const Obj = {
                    fre8ProAccessToken:
                      frProUser?.fre8ProAccessToken,
                    personalInfoId: frProUser?.userId,
                    profileId: frProUser?.userId,
                    userId: frProUser?.userId,
                    title: 'string',
                    displayName: 'string',
                    petName: 'string',
                    firstName: values?.firstName,
                    lastName: values?.lastName,
                    birthday: values?.birthday,
                    birthMonth: values?.birthMonth,
                    birthYear: values?.birthYear,
                    gender: values?.gender,
                    birthDate: `${values?.birthday}-${values?.birthMonth}-${values?.birthYear}`,
                    email: {
                      emailId: values?.userId,
                      email: values?.email,
                      verificationStatus: 'string',
                    },
                    secondaryEmail: {
                      emailId: values?.userId,
                      email: values?.secondaryEmail,
                      verificationStatus: 'string',
                    },
                    mobileNumber: {
                      mobileId: values?.userId,
                      mobile: values?.mobileNumber,
                      verificationStatus: 'string',
                    },
                    secondaryMobileNumber: {
                      mobileId: values?.userId,
                      mobile: values?.secondaryMobileNumber,
                      verificationStatus: 'string',
                    },
                    relationshipStatus: {
                      relationshipStatusId:
                        values?.userId,
                      relationshipStatus:
                        values?.relationshipStatus,
                    },
                    nativePlace: {
                      placeId: values?.userId,
                      placeDisplayName: 'string',
                      country: {
                        countryId: values?.userId,
                        countryName:
                          values?.nativeLocationCountry,
                      },
                      state: {
                        stateId: values?.userId,
                        stateName: values?.nativeLocationState,
                        countryForm: {
                          countryId: values?.userId,
                          countryName:
                            values?.nativeLocationCountry,
                        },
                      },
                      city: {
                        cityId: values?.userId,
                        cityName: values?.nativeLocationCity,
                      },
                      zip: values?.nativeLocationZip,
                    },
                    currentPlaceOfLiving: {
                      placeId: values?.userId,
                      placeDisplayName: 'string',
                      country: {
                        countryId: values?.userId,
                        countryName:
                          values?.currentLocationCountry,
                      },
                      state: {
                        stateId: values?.userId,
                        stateName: values?.currentLocationState,
                        countryForm: {
                          countryId: values?.userId,
                          countryName:
                            values?.currentLocationCountry,
                        },
                      },
                      city: {
                        cityId: values?.userId,
                        cityName: values?.currentLocationCity,
                      },
                      zip: values?.currentLocationZip,
                    },
                    nativePlaceText: 'string',
                    currentPlaceOfLivingText: 'string',
                    aboutMe: 'string',
                  }
                  ProfileApis.userPersonalInfoEdit(Obj)
                    .then((res) => {
                      dispatch(
                        setFrProUser({
                          frProUser: {
                            ...frProUser,
                            updateProfileForm: {
                              ...frProUser?.updateProfileForm,
                              personalInfoForm: res.data,
                            },
                          },
                        })
                      )
                      let item = [
                        {
                          name: 'personal Infomation is updated',
                          type: 'Information Updated',
                        },
                      ]
                      setToasts(item)
                      setTimeout(() => {
                        setToasts(null)
                      }, 3000)
                    })
                    .catch((err) => {
                      console.log(err)
                      let customMessage =
                        'User personal info edit failed'
                      let type = 'User Profile'
                      let color = 'red'
                      ErrorHandle(
                        err,
                        setToasts,
                        customMessage,
                        type,
                        color
                      )
                    })
                  const userMobileObj = {
                    fre8ProAccessToken:
                      frProUser?.fre8ProAccessToken,
                    oldMobileNumber: frProUser?.mobile,
                    mobileNumber: values?.mobileNumber,
                    confirmMobileNumber: values?.mobileNumber,
                  }
                  if (
                    userMobileObj?.mobileNumber !==
                    userMobileObj?.oldMobileNumber
                  ) {
                    ProfileApis.userMobileUpdate(userMobileObj)
                      .then((res) => {
                        dispatch(
                          setMobileVerificationStatus(false)
                        )
                      })
                      .catch((err) => {
                        console.log(err)
                        let customMessage =
                          'User mobile update failed'
                        let type = 'User Profile'
                        let color = 'red'
                        ErrorHandle(
                          err,
                          setToasts,
                          customMessage,
                          type,
                          color
                        )
                      })
                  }

                  const userEmailObj = {
                    fre8ProAccessToken:
                      frProUser.fre8ProAccessToken,
                    oldEmail: frProUser?.email,
                    email: values?.email,
                    confirmEmail: values?.email,
                  }
                  if (
                    userEmailObj?.oldEmail !==
                    userEmailObj?.email
                  ) {
                    ProfileApis.userEmailUpdate(userEmailObj)
                      .then((res) => {
                        dispatch(
                          setEmailVerificationStatus(false)
                        )
                      })
                      .catch((err) => {
                        console.log(err)
                        let customMessage =
                          'User email update failed'
                        let type = 'User Profile'
                        let color = 'red'
                        ErrorHandle(
                          err,
                          setToasts,
                          customMessage,
                          type,
                          color
                        )
                      })
                  }
                }}
                validateOnChange={false}
                validateOnBlur={true}
              >
                {({
                  errors,
                  values,
                  touched,
                  handleSubmit,
                  setFieldTouched,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <>
                      <div className="col-lg-12">
                        <div className="personal mt-4 mb-5 d-flex justify-content-between align-items-center">
                          <h4>Personal details</h4>
                          <button
                            onClick={handleSubmit}
                            type="button"
                            className="btn custom-button py-2 "
                          >
                            Save
                          </button>
                        </div>
                        <div className="basic border-bottom pb-4">
                          <h5>Basic details</h5>
                          <a href="#" className="nav-link">
                            Update your basic details here.
                          </a>
                        </div>
                      </div>
                      <div className="row align-items-center border-bottom pb-4">
                        <div className="col-lg-4">
                          <lable className="lable-color">
                            Name{' '}
                            <span style={{ color: 'red' }}>
                              *
                            </span>
                          </lable>
                        </div>
                        <div className="col-lg-3 mt-3  ">
                          <InputField
                            type="text"
                            placeholder="First name"
                            values={values}
                            name={'firstName'}
                            touched={touched}
                            errors={errors}
                            id="floatingInputGroup1"
                          />
                        </div>
                        <div className="col-lg-3 mt-3">
                          <InputField
                            type="text"
                            placeholder="Last name"
                            values={values}
                            name={'lastName'}
                            touched={touched}
                            errors={errors}
                            id="floatingInputGroup1"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center my-4  border-bottom pb-4">
                        <div className="col-lg-4">
                          <lable className="lable-color">
                            Date of birth{' '}
                            <span style={{ color: 'red' }}>
                              *
                            </span>
                          </lable>
                        </div>
                        <div className="col-lg-2 mb-3 mb-lg-0">
                          <InputField
                            type="text"
                            placeholder="DD"
                            values={values}
                            name={'birthday'}
                            touched={touched}
                            errors={errors}
                            id="floatingInputGroup1"
                          />
                        </div>
                        <div className="col-lg-2 mb-3 mb-lg-0">
                          <InputField
                            type="text"
                            placeholder="MM"
                            values={values}
                            name={'birthMonth'}
                            touched={touched}
                            errors={errors}
                            id="floatingInputGroup1"
                          />
                        </div>
                        <div className="col-lg-2 mb-3 mb-lg-0">
                          <InputField
                            type="text"
                            placeholder="YYYY"
                            values={values}
                            name={'birthYear'}
                            touched={touched}
                            errors={errors}
                            id="floatingInputGroup1"
                          />
                        </div>
                      </div>
                      <div className="row align-items-center my-4  border-bottom pb-4">
                        <div className="col-lg-4">
                          <lable className="lable-color">
                            Gender{' '}
                            <span style={{ color: 'red' }}>
                              *
                            </span>
                          </lable>
                        </div>
                        <div className="col-lg-8 d-flex gap-3">
                          <div className="form-check">
                            <InputField
                              type="radio"
                              values={values}
                              name={'gender'}
                              touched={touched}
                              errors={errors}
                              id="exampleRadios1"
                              radVal="male"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios1"
                            >
                              Male
                            </label>
                          </div>
                          <div className="form-check">
                            <InputField
                              type="radio"
                              values={values}
                              name={'gender'}
                              touched={touched}
                              errors={errors}
                              id="exampleRadios2"
                              radVal="female"
                            />

                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios2"
                            >
                              Female
                            </label>
                          </div>
                          <div className="form-check">
                            <InputField
                              type="radio"
                              values={values}
                              name={'gender'}
                              touched={touched}
                              errors={errors}
                              id="exampleRadios3"
                              radVal="none"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios3"
                            >
                              Prefer not to say
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center pb-4">
                        <div className="col-lg-4">
                          <lable className="lable-color">
                            Relationship status{' '}
                            <span style={{ color: 'red' }}>
                              *
                            </span>
                          </lable>
                        </div>
                        <div className="col-lg-4">
                          <InputField
                            tag="select"
                            values={values}
                            name={'relationshipStatus'}
                            touched={touched}
                            errors={errors}
                            id="floatingInputGroup1"
                            aria-label="Large select example"
                          >
                            {!values?.relationshipStatus && (
                              <option defaultValue={''}>
                                select status
                              </option>
                            )}
                            <option selected>Married</option>
                            <option value="1">Unmarried</option>
                          </InputField>
                        </div>
                      </div>

                      <div className="personal-detais my-4">
                        <div className="col-lg-12">
                          <div className="personal mt-4 mb-5">
                            <h4>Contact details</h4>
                            <div className="basic ">
                              <a href="#" className="nav-link">
                                Update your contact details
                                here.
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="form mt-4">
                          <div className="row border-bottom pb-4">
                            <div className="col-lg-4">
                              <lable className="lable-color">
                                Primary phone number{' '}
                                <span style={{ color: 'red' }}>
                                  *
                                </span>
                              </lable>
                            </div>
                            <div className="col-lg-4">
                              <lable>Phone number</lable>

                              <div className="phone-list pt-2">
                                <div className="input-group phone-input">
                                  <span className="input-group-btn">
                                    <select className="form-select rounded-end-0 h-100 pe-5 ">
                                      <option
                                        defaultValue={
                                          frProUser
                                            ?.updateProfileForm
                                            ?.locationForm
                                            ?.countryForm
                                            ?.countryName
                                        }
                                      >
                                        {
                                          frProUser
                                            ?.updateProfileForm
                                            ?.locationForm
                                            ?.countryForm
                                            ?.countryName
                                        }
                                      </option>
                                    </select>
                                  </span>
                                  <Field
                                    className="form-control"
                                    type="text"
                                    name="mobileNumber"
                                    placeholder="+1 (555) 000-0000"
                                    onBlur={(event) => {
                                      let number =
                                        formatPhoneNumber(
                                          event?.currentTarget
                                            ?.value
                                        )
                                      setFieldValue(
                                        'mobileNumber',
                                        number,
                                        {
                                          shouldValidate: true,
                                        }
                                      )
                                      setFieldTouched(
                                        'mobileNumber',
                                        true,
                                        false
                                      )
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                {touched?.mobileNumber &&
                                  errors?.mobileNumber &&
                                  !numberVerified && (
                                    <FormHelperText
                                      error
                                      id="helper-text-mobile"
                                    >
                                      {errors?.mobileNumber}
                                    </FormHelperText>
                                  )}
                              </div>
                              <div className="verify mt-4 ">
                                {numberVerified ? (
                                  <button className="p-0">
                                    <svg
                                      width="61"
                                      height="22"
                                      viewBox="0 0 61 22"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        style={{
                                          mixBlendMode:
                                            'multiply',
                                        }}
                                      >
                                        <rect
                                          width="61"
                                          height="22"
                                          rx="11"
                                          fill="#ECFDF3"
                                        ></rect>
                                        <path
                                          d="M10.0439 6.27273L12.4728 13.3807H12.5708L14.9998 6.27273H16.4231L13.2825 15H11.7612L8.62056 6.27273H10.0439ZM19.7459 15.1321C19.101 15.1321 18.5456 14.9943 18.0797 14.7188C17.6167 14.4403 17.2587 14.0497 17.0059 13.5469C16.7559 13.0412 16.6309 12.4489 16.6309 11.7699C16.6309 11.0994 16.7559 10.5085 17.0059 9.99716C17.2587 9.4858 17.611 9.08665 18.0627 8.79972C18.5172 8.51278 19.0485 8.36932 19.6564 8.36932C20.0257 8.36932 20.3837 8.4304 20.7303 8.55256C21.0769 8.67472 21.388 8.86648 21.6635 9.12784C21.9391 9.3892 22.1564 9.72869 22.3155 10.1463C22.4746 10.5611 22.5542 11.0653 22.5542 11.6591V12.1108H17.351V11.1562H21.3056C21.3056 10.821 21.2374 10.5241 21.101 10.2656C20.9647 10.0043 20.7729 9.7983 20.5257 9.64773C20.2814 9.49716 19.9945 9.42188 19.665 9.42188C19.307 9.42188 18.9945 9.50994 18.7275 9.68608C18.4632 9.85937 18.2587 10.0866 18.1138 10.3679C17.9718 10.6463 17.9007 10.9489 17.9007 11.2756V12.0213C17.9007 12.4588 17.9775 12.831 18.1309 13.1378C18.2871 13.4446 18.5044 13.679 18.7828 13.8409C19.0613 14 19.3865 14.0795 19.7587 14.0795C20.0002 14.0795 20.2203 14.0455 20.4192 13.9773C20.6181 13.9062 20.79 13.8011 20.9348 13.6619C21.0797 13.5227 21.1905 13.3509 21.2672 13.1463L22.4732 13.3636C22.3766 13.7187 22.2033 14.0298 21.9533 14.2969C21.7061 14.5611 21.3951 14.767 21.0201 14.9148C20.6479 15.0597 20.2232 15.1321 19.7459 15.1321ZM23.9679 15V8.45455H25.1994V9.49432H25.2676C25.3869 9.14205 25.5971 8.86506 25.8983 8.66335C26.2022 8.45881 26.546 8.35653 26.9295 8.35653C27.0091 8.35653 27.1028 8.35937 27.2108 8.36506C27.3216 8.37074 27.4082 8.37784 27.4707 8.38636V9.60511C27.4196 9.59091 27.3287 9.57528 27.198 9.55824C27.0673 9.53835 26.9366 9.52841 26.8059 9.52841C26.5048 9.52841 26.2363 9.59233 26.0005 9.72017C25.7676 9.84517 25.5829 10.0199 25.4466 10.2443C25.3102 10.4659 25.242 10.7187 25.242 11.0028V15H23.9679ZM28.5733 15V8.45455H29.8475V15H28.5733ZM29.2168 7.4446C28.9952 7.4446 28.8049 7.37074 28.6458 7.22301C28.4895 7.07244 28.4114 6.89347 28.4114 6.68608C28.4114 6.47585 28.4895 6.29687 28.6458 6.14915C28.8049 5.99858 28.9952 5.9233 29.2168 5.9233C29.4384 5.9233 29.6273 5.99858 29.7836 6.14915C29.9426 6.29687 30.0222 6.47585 30.0222 6.68608C30.0222 6.89347 29.9426 7.07244 29.7836 7.22301C29.6273 7.37074 29.4384 7.4446 29.2168 7.4446ZM34.6767 8.45455V9.47727H30.9778V8.45455H34.6767ZM31.992 15V7.69602C31.992 7.28693 32.0815 6.94744 32.2605 6.67756C32.4395 6.40483 32.6767 6.2017 32.9721 6.06818C33.2676 5.93182 33.5886 5.86364 33.9352 5.86364C34.1909 5.86364 34.4096 5.88494 34.5914 5.92756C34.7733 5.96733 34.9082 6.00426 34.9963 6.03835L34.698 7.0696C34.6383 7.05256 34.5616 7.03267 34.4679 7.00994C34.3741 6.98437 34.2605 6.97159 34.127 6.97159C33.8173 6.97159 33.5957 7.0483 33.4622 7.2017C33.3315 7.35511 33.2662 7.5767 33.2662 7.86648V15H31.992ZM35.9913 15V8.45455H37.2654V15H35.9913ZM36.6348 7.4446C36.4132 7.4446 36.2228 7.37074 36.0637 7.22301C35.9075 7.07244 35.8294 6.89347 35.8294 6.68608C35.8294 6.47585 35.9075 6.29687 36.0637 6.14915C36.2228 5.99858 36.4132 5.9233 36.6348 5.9233C36.8564 5.9233 37.0453 5.99858 37.2015 6.14915C37.3606 6.29687 37.4402 6.47585 37.4402 6.68608C37.4402 6.89347 37.3606 7.07244 37.2015 7.22301C37.0453 7.37074 36.8564 7.4446 36.6348 7.4446ZM41.8006 15.1321C41.1557 15.1321 40.6003 14.9943 40.1344 14.7188C39.6713 14.4403 39.3134 14.0497 39.0605 13.5469C38.8105 13.0412 38.6855 12.4489 38.6855 11.7699C38.6855 11.0994 38.8105 10.5085 39.0605 9.99716C39.3134 9.4858 39.6657 9.08665 40.1174 8.79972C40.5719 8.51278 41.1032 8.36932 41.7111 8.36932C42.0804 8.36932 42.4384 8.4304 42.785 8.55256C43.1316 8.67472 43.4426 8.86648 43.7182 9.12784C43.9938 9.3892 44.2111 9.72869 44.3702 10.1463C44.5293 10.5611 44.6088 11.0653 44.6088 11.6591V12.1108H39.4057V11.1562H43.3603C43.3603 10.821 43.2921 10.5241 43.1557 10.2656C43.0194 10.0043 42.8276 9.7983 42.5804 9.64773C42.3361 9.49716 42.0492 9.42188 41.7196 9.42188C41.3617 9.42188 41.0492 9.50994 40.7821 9.68608C40.5179 9.85937 40.3134 10.0866 40.1685 10.3679C40.0265 10.6463 39.9554 10.9489 39.9554 11.2756V12.0213C39.9554 12.4588 40.0321 12.831 40.1855 13.1378C40.3418 13.4446 40.5591 13.679 40.8375 13.8409C41.1159 14 41.4412 14.0795 41.8134 14.0795C42.0549 14.0795 42.275 14.0455 42.4739 13.9773C42.6728 13.9062 42.8446 13.8011 42.9895 13.6619C43.1344 13.5227 43.2452 13.3509 43.3219 13.1463L44.5279 13.3636C44.4313 13.7187 44.258 14.0298 44.008 14.2969C43.7608 14.5611 43.4498 14.767 43.0748 14.9148C42.7026 15.0597 42.2779 15.1321 41.8006 15.1321ZM48.4728 15.1278C47.9444 15.1278 47.4728 14.9929 47.0581 14.723C46.6461 14.4503 46.3223 14.0625 46.0865 13.5597C45.8535 13.054 45.737 12.4474 45.737 11.7401C45.737 11.0327 45.8549 10.4276 46.0907 9.92472C46.3294 9.42187 46.6561 9.03693 47.0708 8.76989C47.4856 8.50284 47.9558 8.36932 48.4814 8.36932C48.8876 8.36932 49.2143 8.4375 49.4615 8.57386C49.7115 8.70739 49.9047 8.86364 50.041 9.04261C50.1802 9.22159 50.2882 9.37926 50.3649 9.51562H50.4416V6.27273H51.7157V15H50.4714V13.9815H50.3649C50.2882 14.1207 50.1774 14.2798 50.0325 14.4588C49.8904 14.6378 49.6944 14.794 49.4444 14.9276C49.1944 15.0611 48.8706 15.1278 48.4728 15.1278ZM48.7541 14.0412C49.1206 14.0412 49.4302 13.9446 49.6831 13.7514C49.9387 13.5554 50.1319 13.2841 50.2626 12.9375C50.3961 12.5909 50.4629 12.1875 50.4629 11.7273C50.4629 11.2727 50.3975 10.875 50.2669 10.5341C50.1362 10.1932 49.9444 9.92756 49.6916 9.73722C49.4387 9.54687 49.1262 9.4517 48.7541 9.4517C48.3706 9.4517 48.051 9.55114 47.7953 9.75C47.5396 9.94886 47.3464 10.2202 47.2157 10.5639C47.0879 10.9077 47.024 11.2955 47.024 11.7273C47.024 12.1648 47.0893 12.5582 47.22 12.9077C47.3507 13.2571 47.5439 13.5341 47.7995 13.7386C48.0581 13.9403 48.3762 14.0412 48.7541 14.0412Z"
                                          fill="#027A48"
                                        ></path>
                                      </g>
                                    </svg>
                                  </button>
                                ) : (
                                  <>
                                    <button className="p-0">
                                      <svg
                                        width="84"
                                        height="22"
                                        viewBox="0 0 84 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          style={{
                                            mixBlendMode:
                                              'multiply',
                                          }}
                                        >
                                          <rect
                                            width="84"
                                            height="22"
                                            rx="11"
                                            fill="#FEF3F2"
                                          ></rect>
                                          <path
                                            d="M16.4931 6.27273V15H15.2828L10.8468 8.59943H10.7658V15H9.44904V6.27273H10.6678L15.1081 12.6818H15.1891V6.27273H16.4931ZM21.0687 15.1321C20.4551 15.1321 19.9196 14.9915 19.4622 14.7102C19.0048 14.429 18.6497 14.0355 18.3968 13.5298C18.144 13.0241 18.0176 12.4332 18.0176 11.7571C18.0176 11.0781 18.144 10.4844 18.3968 9.97585C18.6497 9.46733 19.0048 9.07244 19.4622 8.79119C19.9196 8.50994 20.4551 8.36932 21.0687 8.36932C21.6824 8.36932 22.2179 8.50994 22.6752 8.79119C23.1326 9.07244 23.4877 9.46733 23.7406 9.97585C23.9934 10.4844 24.1199 11.0781 24.1199 11.7571C24.1199 12.4332 23.9934 13.0241 23.7406 13.5298C23.4877 14.0355 23.1326 14.429 22.6752 14.7102C22.2179 14.9915 21.6824 15.1321 21.0687 15.1321ZM21.073 14.0625C21.4707 14.0625 21.8002 13.9574 22.0616 13.7472C22.323 13.5369 22.5162 13.2571 22.6412 12.9077C22.769 12.5582 22.8329 12.1733 22.8329 11.7528C22.8329 11.3352 22.769 10.9517 22.6412 10.6023C22.5162 10.25 22.323 9.96733 22.0616 9.75426C21.8002 9.54119 21.4707 9.43466 21.073 9.43466C20.6724 9.43466 20.34 9.54119 20.0758 9.75426C19.8145 9.96733 19.6199 10.25 19.492 10.6023C19.367 10.9517 19.3045 11.3352 19.3045 11.7528C19.3045 12.1733 19.367 12.5582 19.492 12.9077C19.6199 13.2571 19.8145 13.5369 20.0758 13.7472C20.34 13.9574 20.6724 14.0625 21.073 14.0625ZM28.5975 8.45455V9.47727H25.0222V8.45455H28.5975ZM25.981 6.88636H27.2551V13.0781C27.2551 13.3253 27.2921 13.5114 27.3659 13.6364C27.4398 13.7585 27.535 13.8423 27.6515 13.8878C27.7708 13.9304 27.9 13.9517 28.0392 13.9517C28.1415 13.9517 28.231 13.9446 28.3077 13.9304C28.3844 13.9162 28.4441 13.9048 28.4867 13.8963L28.7168 14.9489C28.6429 14.9773 28.5378 15.0057 28.4015 15.0341C28.2651 15.0653 28.0946 15.0824 27.8901 15.0852C27.5549 15.0909 27.2424 15.0312 26.9526 14.9062C26.6628 14.7812 26.4284 14.5881 26.2495 14.3267C26.0705 14.0653 25.981 13.7372 25.981 13.3423V6.88636ZM38.7821 8.45455L36.4086 15H35.0449L32.6671 8.45455H34.035L35.6926 13.4915H35.7608L37.4142 8.45455H38.7821ZM42.5779 15.1321C41.9331 15.1321 41.3777 14.9943 40.9118 14.7188C40.4487 14.4403 40.0907 14.0497 39.8379 13.5469C39.5879 13.0412 39.4629 12.4489 39.4629 11.7699C39.4629 11.0994 39.5879 10.5085 39.8379 9.99716C40.0907 9.4858 40.443 9.08665 40.8947 8.79972C41.3493 8.51278 41.8805 8.36932 42.4885 8.36932C42.8578 8.36932 43.2157 8.4304 43.5623 8.55256C43.9089 8.67472 44.22 8.86648 44.4956 9.12784C44.7711 9.3892 44.9885 9.72869 45.1476 10.1463C45.3066 10.5611 45.3862 11.0653 45.3862 11.6591V12.1108H40.1831V11.1562H44.1376C44.1376 10.821 44.0694 10.5241 43.9331 10.2656C43.7967 10.0043 43.6049 9.7983 43.3578 9.64773C43.1135 9.49716 42.8265 9.42188 42.497 9.42188C42.139 9.42188 41.8265 9.50994 41.5595 9.68608C41.2953 9.85937 41.0907 10.0866 40.9458 10.3679C40.8038 10.6463 40.7328 10.9489 40.7328 11.2756V12.0213C40.7328 12.4588 40.8095 12.831 40.9629 13.1378C41.1191 13.4446 41.3365 13.679 41.6149 13.8409C41.8933 14 42.2186 14.0795 42.5907 14.0795C42.8322 14.0795 43.0524 14.0455 43.2512 13.9773C43.4501 13.9062 43.622 13.8011 43.7669 13.6619C43.9118 13.5227 44.0225 13.3509 44.0993 13.1463L45.3052 13.3636C45.2086 13.7187 45.0353 14.0298 44.7853 14.2969C44.5382 14.5611 44.2271 14.767 43.8521 14.9148C43.4799 15.0597 43.0552 15.1321 42.5779 15.1321ZM46.7999 15V8.45455H48.0314V9.49432H48.0996C48.2189 9.14205 48.4292 8.86506 48.7303 8.66335C49.0343 8.45881 49.378 8.35653 49.7615 8.35653C49.8411 8.35653 49.9348 8.35937 50.0428 8.36506C50.1536 8.37074 50.2402 8.37784 50.3027 8.38636V9.60511C50.2516 9.59091 50.1607 9.57528 50.03 9.55824C49.8993 9.53835 49.7686 9.52841 49.638 9.52841C49.3368 9.52841 49.0684 9.59233 48.8326 9.72017C48.5996 9.84517 48.415 10.0199 48.2786 10.2443C48.1422 10.4659 48.074 10.7187 48.074 11.0028V15H46.7999ZM51.4054 15V8.45455H52.6795V15H51.4054ZM52.0488 7.4446C51.8272 7.4446 51.6369 7.37074 51.4778 7.22301C51.3216 7.07244 51.2434 6.89347 51.2434 6.68608C51.2434 6.47585 51.3216 6.29687 51.4778 6.14915C51.6369 5.99858 51.8272 5.9233 52.0488 5.9233C52.2704 5.9233 52.4593 5.99858 52.6156 6.14915C52.7747 6.29687 52.8542 6.47585 52.8542 6.68608C52.8542 6.89347 52.7747 7.07244 52.6156 7.22301C52.4593 7.37074 52.2704 7.4446 52.0488 7.4446ZM57.5087 8.45455V9.47727H53.8098V8.45455H57.5087ZM54.824 15V7.69602C54.824 7.28693 54.9135 6.94744 55.0925 6.67756C55.2715 6.40483 55.5087 6.2017 55.8042 6.06818C56.0996 5.93182 56.4206 5.86364 56.7672 5.86364C57.0229 5.86364 57.2417 5.88494 57.4235 5.92756C57.6053 5.96733 57.7402 6.00426 57.8283 6.03835L57.53 7.0696C57.4703 7.05256 57.3936 7.03267 57.2999 7.00994C57.2061 6.98437 57.0925 6.97159 56.959 6.97159C56.6493 6.97159 56.4277 7.0483 56.2942 7.2017C56.1635 7.35511 56.0982 7.5767 56.0982 7.86648V15H54.824ZM58.8233 15V8.45455H60.0975V15H58.8233ZM59.4668 7.4446C59.2452 7.4446 59.0549 7.37074 58.8958 7.22301C58.7395 7.07244 58.6614 6.89347 58.6614 6.68608C58.6614 6.47585 58.7395 6.29687 58.8958 6.14915C59.0549 5.99858 59.2452 5.9233 59.4668 5.9233C59.6884 5.9233 59.8773 5.99858 60.0336 6.14915C60.1926 6.29687 60.2722 6.47585 60.2722 6.68608C60.2722 6.89347 60.1926 7.07244 60.0336 7.22301C59.8773 7.37074 59.6884 7.4446 59.4668 7.4446ZM64.6326 15.1321C63.9877 15.1321 63.4324 14.9943 62.9664 14.7188C62.5034 14.4403 62.1454 14.0497 61.8926 13.5469C61.6426 13.0412 61.5176 12.4489 61.5176 11.7699C61.5176 11.0994 61.6426 10.5085 61.8926 9.99716C62.1454 9.4858 62.4977 9.08665 62.9494 8.79972C63.4039 8.51278 63.9352 8.36932 64.5431 8.36932C64.9125 8.36932 65.2704 8.4304 65.617 8.55256C65.9636 8.67472 66.2747 8.86648 66.5502 9.12784C66.8258 9.3892 67.0431 9.72869 67.2022 10.1463C67.3613 10.5611 67.4409 11.0653 67.4409 11.6591V12.1108H62.2377V11.1562H66.1923C66.1923 10.821 66.1241 10.5241 65.9877 10.2656C65.8514 10.0043 65.6596 9.7983 65.4125 9.64773C65.1681 9.49716 64.8812 9.42188 64.5517 9.42188C64.1937 9.42188 63.8812 9.50994 63.6142 9.68608C63.35 9.85937 63.1454 10.0866 63.0005 10.3679C62.8585 10.6463 62.7875 10.9489 62.7875 11.2756V12.0213C62.7875 12.4588 62.8642 12.831 63.0176 13.1378C63.1738 13.4446 63.3912 13.679 63.6696 13.8409C63.948 14 64.2733 14.0795 64.6454 14.0795C64.8869 14.0795 65.1071 14.0455 65.3059 13.9773C65.5048 13.9062 65.6767 13.8011 65.8216 13.6619C65.9664 13.5227 66.0772 13.3509 66.1539 13.1463L67.3599 13.3636C67.2633 13.7187 67.09 14.0298 66.84 14.2969C66.5929 14.5611 66.2818 14.767 65.9068 14.9148C65.5346 15.0597 65.1099 15.1321 64.6326 15.1321ZM71.3049 15.1278C70.7765 15.1278 70.3049 14.9929 69.8901 14.723C69.4782 14.4503 69.1543 14.0625 68.9185 13.5597C68.6855 13.054 68.5691 12.4474 68.5691 11.7401C68.5691 11.0327 68.687 10.4276 68.9228 9.92472C69.1614 9.42187 69.4881 9.03693 69.9029 8.76989C70.3176 8.50284 70.7878 8.36932 71.3134 8.36932C71.7196 8.36932 72.0463 8.4375 72.2935 8.57386C72.5435 8.70739 72.7367 8.86364 72.873 9.04261C73.0123 9.22159 73.1202 9.37926 73.1969 9.51562H73.2736V6.27273H74.5478V15H73.3034V13.9815H73.1969C73.1202 14.1207 73.0094 14.2798 72.8645 14.4588C72.7225 14.6378 72.5265 14.794 72.2765 14.9276C72.0265 15.0611 71.7026 15.1278 71.3049 15.1278ZM71.5861 14.0412C71.9526 14.0412 72.2623 13.9446 72.5151 13.7514C72.7708 13.5554 72.964 13.2841 73.0946 12.9375C73.2282 12.5909 73.2949 12.1875 73.2949 11.7273C73.2949 11.2727 73.2296 10.875 73.0989 10.5341C72.9682 10.1932 72.7765 9.92756 72.5236 9.73722C72.2708 9.54687 71.9583 9.4517 71.5861 9.4517C71.2026 9.4517 70.883 9.55114 70.6273 9.75C70.3716 9.94886 70.1784 10.2202 70.0478 10.5639C69.9199 10.9077 69.856 11.2955 69.856 11.7273C69.856 12.1648 69.9213 12.5582 70.052 12.9077C70.1827 13.2571 70.3759 13.5341 70.6316 13.7386C70.8901 13.9403 71.2083 14.0412 71.5861 14.0412Z"
                                            fill="#B42318"
                                          ></path>
                                        </g>
                                      </svg>
                                    </button>
                                    <Typography
                                      component={Link}
                                      className={''}
                                      to="/verificationmobile"
                                      color="textSecondary"
                                      variant="h6"
                                      sx={{
                                        textDecoration: 'none',
                                        fontSize: '1rem',
                                        margin: '12px 0',
                                      }}
                                    >
                                      {' '}
                                      Verify
                                    </Typography>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row border-bottom pb-4 pt-4">
                            <div className="col-lg-4">
                              <lable className="lable-color">
                                Secodary phone number
                              </lable>
                            </div>
                            <div className="col-lg-4">
                              <lable>Phone number</lable>

                              <div className="phone-list pt-2">
                                <div className="input-group phone-input">
                                  <span className="input-group-btn">
                                    <select className="form-select rounded-end-0 h-100 pe-5 ">
                                      <option
                                        defaultValue={
                                          frProUser
                                            ?.updateProfileForm
                                            ?.locationForm
                                            ?.countryForm
                                            ?.countryName
                                        }
                                      >
                                        {
                                          frProUser
                                            ?.updateProfileForm
                                            ?.locationForm
                                            ?.countryForm
                                            ?.countryName
                                        }
                                      </option>
                                    </select>
                                  </span>
                                  <Field
                                    className="form-control"
                                    type="text"
                                    name="secondaryMobileNumber"
                                    placeholder="+1 (555) 000-0000"
                                    onBlur={(event) => {
                                      let number =
                                        formatPhoneNumber(
                                          event?.currentTarget
                                            ?.value
                                        )
                                      setFieldValue(
                                        'secondaryMobileNumber',
                                        number,
                                        {
                                          shouldValidate: true,
                                        }
                                      )
                                      setFieldTouched(
                                        'secondaryMobileNumber',
                                        true,
                                        false
                                      )
                                    }}
                                  />

                                  {touched?.secondaryMobileNumber &&
                                    errors?.secondaryMobileNumber && (
                                      <FormHelperText
                                        error
                                        id="helper-text-email"
                                      >
                                        {
                                          errors?.secondaryMobileNumber
                                        }
                                      </FormHelperText>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row border-bottom pb-4 pt-4">
                            <div className="col-lg-4">
                              <lable className="lable-color">
                                Email address{' '}
                                <span style={{ color: 'red' }}>
                                  *
                                </span>
                              </lable>
                            </div>
                            <div className="col-lg-4">
                              <div className="phone-list pt-2">
                                <Field
                                  className="form-control"
                                  type="email"
                                  name="email"
                                  placeholder="Please provide email id"
                                />
                              </div>
                              {touched?.email &&
                                errors?.email &&
                                !emailVerified && (
                                  <FormHelperText
                                    error
                                    id="helper-text-email"
                                  >
                                    {errors?.email}
                                  </FormHelperText>
                                )}
                              <div className="verify mt-4 ">
                                {emailVerified ? (
                                  <button className="p-0">
                                    <svg
                                      width="61"
                                      height="22"
                                      viewBox="0 0 61 22"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g
                                        style={{
                                          mixBlendMode:
                                            'multiply',
                                        }}
                                      >
                                        <rect
                                          width="61"
                                          height="22"
                                          rx="11"
                                          fill="#ECFDF3"
                                        ></rect>
                                        <path
                                          d="M10.0439 6.27273L12.4728 13.3807H12.5708L14.9998 6.27273H16.4231L13.2825 15H11.7612L8.62056 6.27273H10.0439ZM19.7459 15.1321C19.101 15.1321 18.5456 14.9943 18.0797 14.7188C17.6167 14.4403 17.2587 14.0497 17.0059 13.5469C16.7559 13.0412 16.6309 12.4489 16.6309 11.7699C16.6309 11.0994 16.7559 10.5085 17.0059 9.99716C17.2587 9.4858 17.611 9.08665 18.0627 8.79972C18.5172 8.51278 19.0485 8.36932 19.6564 8.36932C20.0257 8.36932 20.3837 8.4304 20.7303 8.55256C21.0769 8.67472 21.388 8.86648 21.6635 9.12784C21.9391 9.3892 22.1564 9.72869 22.3155 10.1463C22.4746 10.5611 22.5542 11.0653 22.5542 11.6591V12.1108H17.351V11.1562H21.3056C21.3056 10.821 21.2374 10.5241 21.101 10.2656C20.9647 10.0043 20.7729 9.7983 20.5257 9.64773C20.2814 9.49716 19.9945 9.42188 19.665 9.42188C19.307 9.42188 18.9945 9.50994 18.7275 9.68608C18.4632 9.85937 18.2587 10.0866 18.1138 10.3679C17.9718 10.6463 17.9007 10.9489 17.9007 11.2756V12.0213C17.9007 12.4588 17.9775 12.831 18.1309 13.1378C18.2871 13.4446 18.5044 13.679 18.7828 13.8409C19.0613 14 19.3865 14.0795 19.7587 14.0795C20.0002 14.0795 20.2203 14.0455 20.4192 13.9773C20.6181 13.9062 20.79 13.8011 20.9348 13.6619C21.0797 13.5227 21.1905 13.3509 21.2672 13.1463L22.4732 13.3636C22.3766 13.7187 22.2033 14.0298 21.9533 14.2969C21.7061 14.5611 21.3951 14.767 21.0201 14.9148C20.6479 15.0597 20.2232 15.1321 19.7459 15.1321ZM23.9679 15V8.45455H25.1994V9.49432H25.2676C25.3869 9.14205 25.5971 8.86506 25.8983 8.66335C26.2022 8.45881 26.546 8.35653 26.9295 8.35653C27.0091 8.35653 27.1028 8.35937 27.2108 8.36506C27.3216 8.37074 27.4082 8.37784 27.4707 8.38636V9.60511C27.4196 9.59091 27.3287 9.57528 27.198 9.55824C27.0673 9.53835 26.9366 9.52841 26.8059 9.52841C26.5048 9.52841 26.2363 9.59233 26.0005 9.72017C25.7676 9.84517 25.5829 10.0199 25.4466 10.2443C25.3102 10.4659 25.242 10.7187 25.242 11.0028V15H23.9679ZM28.5733 15V8.45455H29.8475V15H28.5733ZM29.2168 7.4446C28.9952 7.4446 28.8049 7.37074 28.6458 7.22301C28.4895 7.07244 28.4114 6.89347 28.4114 6.68608C28.4114 6.47585 28.4895 6.29687 28.6458 6.14915C28.8049 5.99858 28.9952 5.9233 29.2168 5.9233C29.4384 5.9233 29.6273 5.99858 29.7836 6.14915C29.9426 6.29687 30.0222 6.47585 30.0222 6.68608C30.0222 6.89347 29.9426 7.07244 29.7836 7.22301C29.6273 7.37074 29.4384 7.4446 29.2168 7.4446ZM34.6767 8.45455V9.47727H30.9778V8.45455H34.6767ZM31.992 15V7.69602C31.992 7.28693 32.0815 6.94744 32.2605 6.67756C32.4395 6.40483 32.6767 6.2017 32.9721 6.06818C33.2676 5.93182 33.5886 5.86364 33.9352 5.86364C34.1909 5.86364 34.4096 5.88494 34.5914 5.92756C34.7733 5.96733 34.9082 6.00426 34.9963 6.03835L34.698 7.0696C34.6383 7.05256 34.5616 7.03267 34.4679 7.00994C34.3741 6.98437 34.2605 6.97159 34.127 6.97159C33.8173 6.97159 33.5957 7.0483 33.4622 7.2017C33.3315 7.35511 33.2662 7.5767 33.2662 7.86648V15H31.992ZM35.9913 15V8.45455H37.2654V15H35.9913ZM36.6348 7.4446C36.4132 7.4446 36.2228 7.37074 36.0637 7.22301C35.9075 7.07244 35.8294 6.89347 35.8294 6.68608C35.8294 6.47585 35.9075 6.29687 36.0637 6.14915C36.2228 5.99858 36.4132 5.9233 36.6348 5.9233C36.8564 5.9233 37.0453 5.99858 37.2015 6.14915C37.3606 6.29687 37.4402 6.47585 37.4402 6.68608C37.4402 6.89347 37.3606 7.07244 37.2015 7.22301C37.0453 7.37074 36.8564 7.4446 36.6348 7.4446ZM41.8006 15.1321C41.1557 15.1321 40.6003 14.9943 40.1344 14.7188C39.6713 14.4403 39.3134 14.0497 39.0605 13.5469C38.8105 13.0412 38.6855 12.4489 38.6855 11.7699C38.6855 11.0994 38.8105 10.5085 39.0605 9.99716C39.3134 9.4858 39.6657 9.08665 40.1174 8.79972C40.5719 8.51278 41.1032 8.36932 41.7111 8.36932C42.0804 8.36932 42.4384 8.4304 42.785 8.55256C43.1316 8.67472 43.4426 8.86648 43.7182 9.12784C43.9938 9.3892 44.2111 9.72869 44.3702 10.1463C44.5293 10.5611 44.6088 11.0653 44.6088 11.6591V12.1108H39.4057V11.1562H43.3603C43.3603 10.821 43.2921 10.5241 43.1557 10.2656C43.0194 10.0043 42.8276 9.7983 42.5804 9.64773C42.3361 9.49716 42.0492 9.42188 41.7196 9.42188C41.3617 9.42188 41.0492 9.50994 40.7821 9.68608C40.5179 9.85937 40.3134 10.0866 40.1685 10.3679C40.0265 10.6463 39.9554 10.9489 39.9554 11.2756V12.0213C39.9554 12.4588 40.0321 12.831 40.1855 13.1378C40.3418 13.4446 40.5591 13.679 40.8375 13.8409C41.1159 14 41.4412 14.0795 41.8134 14.0795C42.0549 14.0795 42.275 14.0455 42.4739 13.9773C42.6728 13.9062 42.8446 13.8011 42.9895 13.6619C43.1344 13.5227 43.2452 13.3509 43.3219 13.1463L44.5279 13.3636C44.4313 13.7187 44.258 14.0298 44.008 14.2969C43.7608 14.5611 43.4498 14.767 43.0748 14.9148C42.7026 15.0597 42.2779 15.1321 41.8006 15.1321ZM48.4728 15.1278C47.9444 15.1278 47.4728 14.9929 47.0581 14.723C46.6461 14.4503 46.3223 14.0625 46.0865 13.5597C45.8535 13.054 45.737 12.4474 45.737 11.7401C45.737 11.0327 45.8549 10.4276 46.0907 9.92472C46.3294 9.42187 46.6561 9.03693 47.0708 8.76989C47.4856 8.50284 47.9558 8.36932 48.4814 8.36932C48.8876 8.36932 49.2143 8.4375 49.4615 8.57386C49.7115 8.70739 49.9047 8.86364 50.041 9.04261C50.1802 9.22159 50.2882 9.37926 50.3649 9.51562H50.4416V6.27273H51.7157V15H50.4714V13.9815H50.3649C50.2882 14.1207 50.1774 14.2798 50.0325 14.4588C49.8904 14.6378 49.6944 14.794 49.4444 14.9276C49.1944 15.0611 48.8706 15.1278 48.4728 15.1278ZM48.7541 14.0412C49.1206 14.0412 49.4302 13.9446 49.6831 13.7514C49.9387 13.5554 50.1319 13.2841 50.2626 12.9375C50.3961 12.5909 50.4629 12.1875 50.4629 11.7273C50.4629 11.2727 50.3975 10.875 50.2669 10.5341C50.1362 10.1932 49.9444 9.92756 49.6916 9.73722C49.4387 9.54687 49.1262 9.4517 48.7541 9.4517C48.3706 9.4517 48.051 9.55114 47.7953 9.75C47.5396 9.94886 47.3464 10.2202 47.2157 10.5639C47.0879 10.9077 47.024 11.2955 47.024 11.7273C47.024 12.1648 47.0893 12.5582 47.22 12.9077C47.3507 13.2571 47.5439 13.5341 47.7995 13.7386C48.0581 13.9403 48.3762 14.0412 48.7541 14.0412Z"
                                          fill="#027A48"
                                        ></path>
                                      </g>
                                    </svg>
                                  </button>
                                ) : (
                                  <>
                                    <button className="p-0">
                                      <svg
                                        width="84"
                                        height="22"
                                        viewBox="0 0 84 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g
                                          style={{
                                            mixBlendMode:
                                              'multiply',
                                          }}
                                        >
                                          <rect
                                            width="84"
                                            height="22"
                                            rx="11"
                                            fill="#FEF3F2"
                                          ></rect>
                                          <path
                                            d="M16.4931 6.27273V15H15.2828L10.8468 8.59943H10.7658V15H9.44904V6.27273H10.6678L15.1081 12.6818H15.1891V6.27273H16.4931ZM21.0687 15.1321C20.4551 15.1321 19.9196 14.9915 19.4622 14.7102C19.0048 14.429 18.6497 14.0355 18.3968 13.5298C18.144 13.0241 18.0176 12.4332 18.0176 11.7571C18.0176 11.0781 18.144 10.4844 18.3968 9.97585C18.6497 9.46733 19.0048 9.07244 19.4622 8.79119C19.9196 8.50994 20.4551 8.36932 21.0687 8.36932C21.6824 8.36932 22.2179 8.50994 22.6752 8.79119C23.1326 9.07244 23.4877 9.46733 23.7406 9.97585C23.9934 10.4844 24.1199 11.0781 24.1199 11.7571C24.1199 12.4332 23.9934 13.0241 23.7406 13.5298C23.4877 14.0355 23.1326 14.429 22.6752 14.7102C22.2179 14.9915 21.6824 15.1321 21.0687 15.1321ZM21.073 14.0625C21.4707 14.0625 21.8002 13.9574 22.0616 13.7472C22.323 13.5369 22.5162 13.2571 22.6412 12.9077C22.769 12.5582 22.8329 12.1733 22.8329 11.7528C22.8329 11.3352 22.769 10.9517 22.6412 10.6023C22.5162 10.25 22.323 9.96733 22.0616 9.75426C21.8002 9.54119 21.4707 9.43466 21.073 9.43466C20.6724 9.43466 20.34 9.54119 20.0758 9.75426C19.8145 9.96733 19.6199 10.25 19.492 10.6023C19.367 10.9517 19.3045 11.3352 19.3045 11.7528C19.3045 12.1733 19.367 12.5582 19.492 12.9077C19.6199 13.2571 19.8145 13.5369 20.0758 13.7472C20.34 13.9574 20.6724 14.0625 21.073 14.0625ZM28.5975 8.45455V9.47727H25.0222V8.45455H28.5975ZM25.981 6.88636H27.2551V13.0781C27.2551 13.3253 27.2921 13.5114 27.3659 13.6364C27.4398 13.7585 27.535 13.8423 27.6515 13.8878C27.7708 13.9304 27.9 13.9517 28.0392 13.9517C28.1415 13.9517 28.231 13.9446 28.3077 13.9304C28.3844 13.9162 28.4441 13.9048 28.4867 13.8963L28.7168 14.9489C28.6429 14.9773 28.5378 15.0057 28.4015 15.0341C28.2651 15.0653 28.0946 15.0824 27.8901 15.0852C27.5549 15.0909 27.2424 15.0312 26.9526 14.9062C26.6628 14.7812 26.4284 14.5881 26.2495 14.3267C26.0705 14.0653 25.981 13.7372 25.981 13.3423V6.88636ZM38.7821 8.45455L36.4086 15H35.0449L32.6671 8.45455H34.035L35.6926 13.4915H35.7608L37.4142 8.45455H38.7821ZM42.5779 15.1321C41.9331 15.1321 41.3777 14.9943 40.9118 14.7188C40.4487 14.4403 40.0907 14.0497 39.8379 13.5469C39.5879 13.0412 39.4629 12.4489 39.4629 11.7699C39.4629 11.0994 39.5879 10.5085 39.8379 9.99716C40.0907 9.4858 40.443 9.08665 40.8947 8.79972C41.3493 8.51278 41.8805 8.36932 42.4885 8.36932C42.8578 8.36932 43.2157 8.4304 43.5623 8.55256C43.9089 8.67472 44.22 8.86648 44.4956 9.12784C44.7711 9.3892 44.9885 9.72869 45.1476 10.1463C45.3066 10.5611 45.3862 11.0653 45.3862 11.6591V12.1108H40.1831V11.1562H44.1376C44.1376 10.821 44.0694 10.5241 43.9331 10.2656C43.7967 10.0043 43.6049 9.7983 43.3578 9.64773C43.1135 9.49716 42.8265 9.42188 42.497 9.42188C42.139 9.42188 41.8265 9.50994 41.5595 9.68608C41.2953 9.85937 41.0907 10.0866 40.9458 10.3679C40.8038 10.6463 40.7328 10.9489 40.7328 11.2756V12.0213C40.7328 12.4588 40.8095 12.831 40.9629 13.1378C41.1191 13.4446 41.3365 13.679 41.6149 13.8409C41.8933 14 42.2186 14.0795 42.5907 14.0795C42.8322 14.0795 43.0524 14.0455 43.2512 13.9773C43.4501 13.9062 43.622 13.8011 43.7669 13.6619C43.9118 13.5227 44.0225 13.3509 44.0993 13.1463L45.3052 13.3636C45.2086 13.7187 45.0353 14.0298 44.7853 14.2969C44.5382 14.5611 44.2271 14.767 43.8521 14.9148C43.4799 15.0597 43.0552 15.1321 42.5779 15.1321ZM46.7999 15V8.45455H48.0314V9.49432H48.0996C48.2189 9.14205 48.4292 8.86506 48.7303 8.66335C49.0343 8.45881 49.378 8.35653 49.7615 8.35653C49.8411 8.35653 49.9348 8.35937 50.0428 8.36506C50.1536 8.37074 50.2402 8.37784 50.3027 8.38636V9.60511C50.2516 9.59091 50.1607 9.57528 50.03 9.55824C49.8993 9.53835 49.7686 9.52841 49.638 9.52841C49.3368 9.52841 49.0684 9.59233 48.8326 9.72017C48.5996 9.84517 48.415 10.0199 48.2786 10.2443C48.1422 10.4659 48.074 10.7187 48.074 11.0028V15H46.7999ZM51.4054 15V8.45455H52.6795V15H51.4054ZM52.0488 7.4446C51.8272 7.4446 51.6369 7.37074 51.4778 7.22301C51.3216 7.07244 51.2434 6.89347 51.2434 6.68608C51.2434 6.47585 51.3216 6.29687 51.4778 6.14915C51.6369 5.99858 51.8272 5.9233 52.0488 5.9233C52.2704 5.9233 52.4593 5.99858 52.6156 6.14915C52.7747 6.29687 52.8542 6.47585 52.8542 6.68608C52.8542 6.89347 52.7747 7.07244 52.6156 7.22301C52.4593 7.37074 52.2704 7.4446 52.0488 7.4446ZM57.5087 8.45455V9.47727H53.8098V8.45455H57.5087ZM54.824 15V7.69602C54.824 7.28693 54.9135 6.94744 55.0925 6.67756C55.2715 6.40483 55.5087 6.2017 55.8042 6.06818C56.0996 5.93182 56.4206 5.86364 56.7672 5.86364C57.0229 5.86364 57.2417 5.88494 57.4235 5.92756C57.6053 5.96733 57.7402 6.00426 57.8283 6.03835L57.53 7.0696C57.4703 7.05256 57.3936 7.03267 57.2999 7.00994C57.2061 6.98437 57.0925 6.97159 56.959 6.97159C56.6493 6.97159 56.4277 7.0483 56.2942 7.2017C56.1635 7.35511 56.0982 7.5767 56.0982 7.86648V15H54.824ZM58.8233 15V8.45455H60.0975V15H58.8233ZM59.4668 7.4446C59.2452 7.4446 59.0549 7.37074 58.8958 7.22301C58.7395 7.07244 58.6614 6.89347 58.6614 6.68608C58.6614 6.47585 58.7395 6.29687 58.8958 6.14915C59.0549 5.99858 59.2452 5.9233 59.4668 5.9233C59.6884 5.9233 59.8773 5.99858 60.0336 6.14915C60.1926 6.29687 60.2722 6.47585 60.2722 6.68608C60.2722 6.89347 60.1926 7.07244 60.0336 7.22301C59.8773 7.37074 59.6884 7.4446 59.4668 7.4446ZM64.6326 15.1321C63.9877 15.1321 63.4324 14.9943 62.9664 14.7188C62.5034 14.4403 62.1454 14.0497 61.8926 13.5469C61.6426 13.0412 61.5176 12.4489 61.5176 11.7699C61.5176 11.0994 61.6426 10.5085 61.8926 9.99716C62.1454 9.4858 62.4977 9.08665 62.9494 8.79972C63.4039 8.51278 63.9352 8.36932 64.5431 8.36932C64.9125 8.36932 65.2704 8.4304 65.617 8.55256C65.9636 8.67472 66.2747 8.86648 66.5502 9.12784C66.8258 9.3892 67.0431 9.72869 67.2022 10.1463C67.3613 10.5611 67.4409 11.0653 67.4409 11.6591V12.1108H62.2377V11.1562H66.1923C66.1923 10.821 66.1241 10.5241 65.9877 10.2656C65.8514 10.0043 65.6596 9.7983 65.4125 9.64773C65.1681 9.49716 64.8812 9.42188 64.5517 9.42188C64.1937 9.42188 63.8812 9.50994 63.6142 9.68608C63.35 9.85937 63.1454 10.0866 63.0005 10.3679C62.8585 10.6463 62.7875 10.9489 62.7875 11.2756V12.0213C62.7875 12.4588 62.8642 12.831 63.0176 13.1378C63.1738 13.4446 63.3912 13.679 63.6696 13.8409C63.948 14 64.2733 14.0795 64.6454 14.0795C64.8869 14.0795 65.1071 14.0455 65.3059 13.9773C65.5048 13.9062 65.6767 13.8011 65.8216 13.6619C65.9664 13.5227 66.0772 13.3509 66.1539 13.1463L67.3599 13.3636C67.2633 13.7187 67.09 14.0298 66.84 14.2969C66.5929 14.5611 66.2818 14.767 65.9068 14.9148C65.5346 15.0597 65.1099 15.1321 64.6326 15.1321ZM71.3049 15.1278C70.7765 15.1278 70.3049 14.9929 69.8901 14.723C69.4782 14.4503 69.1543 14.0625 68.9185 13.5597C68.6855 13.054 68.5691 12.4474 68.5691 11.7401C68.5691 11.0327 68.687 10.4276 68.9228 9.92472C69.1614 9.42187 69.4881 9.03693 69.9029 8.76989C70.3176 8.50284 70.7878 8.36932 71.3134 8.36932C71.7196 8.36932 72.0463 8.4375 72.2935 8.57386C72.5435 8.70739 72.7367 8.86364 72.873 9.04261C73.0123 9.22159 73.1202 9.37926 73.1969 9.51562H73.2736V6.27273H74.5478V15H73.3034V13.9815H73.1969C73.1202 14.1207 73.0094 14.2798 72.8645 14.4588C72.7225 14.6378 72.5265 14.794 72.2765 14.9276C72.0265 15.0611 71.7026 15.1278 71.3049 15.1278ZM71.5861 14.0412C71.9526 14.0412 72.2623 13.9446 72.5151 13.7514C72.7708 13.5554 72.964 13.2841 73.0946 12.9375C73.2282 12.5909 73.2949 12.1875 73.2949 11.7273C73.2949 11.2727 73.2296 10.875 73.0989 10.5341C72.9682 10.1932 72.7765 9.92756 72.5236 9.73722C72.2708 9.54687 71.9583 9.4517 71.5861 9.4517C71.2026 9.4517 70.883 9.55114 70.6273 9.75C70.3716 9.94886 70.1784 10.2202 70.0478 10.5639C69.9199 10.9077 69.856 11.2955 69.856 11.7273C69.856 12.1648 69.9213 12.5582 70.052 12.9077C70.1827 13.2571 70.3759 13.5341 70.6316 13.7386C70.8901 13.9403 71.2083 14.0412 71.5861 14.0412Z"
                                            fill="#B42318"
                                          ></path>
                                        </g>
                                      </svg>
                                    </button>
                                    <Typography
                                      component={Link}
                                      className={''}
                                      to="/verificationemail"
                                      color="textSecondary"
                                      variant="h6"
                                      sx={{
                                        textDecoration: 'none',
                                        fontSize: '1rem',
                                        margin: '12px 0',
                                      }}
                                    >
                                      {' '}
                                      Verify
                                    </Typography>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row align-items-top pb-4 mt-4">
                            <div className="col-lg-4">
                              <lable className="lable-color">
                                Secondary email address
                              </lable>
                            </div>
                            <div className="col-lg-4">
                              <InputField
                                type="text"
                                placeholder="secondary email address"
                                values={values}
                                name={'secondaryEmail'}
                                touched={touched}
                                errors={errors}
                                id="floatingInputGroup1"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <!--========================Current-details start here======================================================--> */}
                      <div className="Current-details mt-4">
                        <h4>Current location</h4>
                        <div className="basic  pb-5 border-bottom">
                          <a href="#" className="nav-link">
                            Update your location details here.
                          </a>
                        </div>
                        <div className="row align-items-top pb-4 pt-4">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              Country{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <span className="input-group-btn">
                              <select
                                id="country"
                                value={selectedCurrentCountry}
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setFieldValue(
                                    'currentLocationCountry',
                                    e?.currentTarget?.value,
                                    {
                                      shouldValidate: true,
                                    }
                                  )
                                  //alert(e?.currentTarget?.value)
                                  handleCountryChange(
                                    e,
                                    'current'
                                  )
                                }}
                              >
                                {values?.currentLocationCountry ? (
                                  <option
                                    value={
                                      values?.currentLocationCountry
                                    }
                                  >
                                    {
                                      values?.currentLocationCountry
                                    }
                                  </option>
                                ) : (
                                  <option>
                                    Select Country{' '}
                                  </option>
                                )}
                                {currentcountries?.map(
                                  (country) => {
                                    return (
                                      country?.countryName !==
                                      'Mexico' && (
                                        <option
                                          key={
                                            country?.countryId
                                          }
                                          value={
                                            country?.countryName
                                          }
                                        >
                                          {country?.countryName}
                                        </option>
                                      )
                                    )
                                  }
                                )}
                              </select>
                              {touched?.selectedCurrentCountry &&
                                errors?.selectedCurrentCountry && (
                                  <FormHelperText
                                    error
                                    id="helper-text-fre8ProUserId"
                                  >
                                    {
                                      errors?.selectedCurrentCountry
                                    }
                                  </FormHelperText>
                                )}
                            </span>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4 mt-1">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              State{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <span className="input-group-btn">
                              <select
                                id="state"
                                value={selectedCurrentState}
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setFieldValue(
                                    'currentLocationState',
                                    e?.currentTarget?.value,
                                    {
                                      shouldValidate: true,
                                    }
                                  )
                                  handleStateChange(
                                    e,
                                    'current'
                                  )
                                }}
                              >
                                {values?.currentLocationState ? (
                                  <option
                                    defaultValue={
                                      values?.currentLocationState
                                    }
                                  >
                                    {
                                      values?.currentLocationState
                                    }
                                  </option>
                                ) : (
                                  <option defaultChecked="">
                                    Select State{' '}
                                  </option>
                                )}
                                {/* {countries?.find(c => c.name === selectedCountry)?.states?.map(state => ( */}
                                {currentstates?.map((state) => (
                                  <option
                                    key={state?.stateId}
                                    value={state?.stateName}
                                  >
                                    {state?.stateName}
                                  </option>
                                ))}
                              </select>
                              {touched?.selectedCurrentState &&
                                errors?.selectedCurrentState && (
                                  <FormHelperText
                                    error
                                    id="helper-text-fre8ProUserId"
                                  >
                                    {
                                      errors?.selectedCurrentState
                                    }
                                  </FormHelperText>
                                )}
                            </span>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4 mt-1">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              City{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <span className="input-group-btn">
                              <InputField
                                tag={'select'}
                                values={values}
                                name={'currentLocationCity'}
                                touched={touched}
                                errors={errors}
                              // handleCountryChange={handleCountryChange}
                              // onChange={(e)=>handleCountryChange(e.target.value)}
                              >
                                {values?.currentLocationCity ? (
                                  <option
                                    defaultValue={
                                      values?.currentLocationCity
                                    }
                                  >
                                    {
                                      values?.currentLocationCity
                                    }
                                  </option>
                                ) : (
                                  <option defaultChecked="">
                                    Select City{' '}
                                  </option>
                                )}
                                {values?.currentLocationCountry ===
                                  'Canada'
                                  ? CanadaStates[
                                    values
                                      ?.currentLocationState
                                  ]?.cities?.map((cites) => (
                                    <option
                                      key={cites}
                                      value={cites}
                                    >
                                      {cites}
                                    </option>
                                  ))
                                  : UsaStates[
                                    values
                                      ?.currentLocationState
                                  ]?.cities?.map((cites) => (
                                    <option
                                      key={cites}
                                      value={cites}
                                    >
                                      {cites}
                                    </option>
                                  ))}
                              </InputField>
                            </span>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              ZIP{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <InputField
                              tag={'select'}
                              values={values}
                              name={'currentLocationZip'}
                              touched={touched}
                              errors={errors}
                            >
                              {values?.currentLocationZip ? (
                                <option
                                  defaultValue={
                                    values?.currentLocationZip
                                  }
                                >
                                  {values?.currentLocationZip}
                                </option>
                              ) : (
                                <option defaultChecked="">
                                  Select Zip{' '}
                                </option>
                              )}
                              <option value="C0A">C0A</option>
                              <option value="T5J">T5J</option>
                              <option value="E3A">E3A</option>
                              <option value="E5R">E5R</option>
                              <option value="S3A">S3A</option>
                              <option value="H5E">H5E</option>
                            </InputField>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4 mt-1 border-top border-bottom pt-4">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              Timezone
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <span className="input-group-btn position-relative">
                              <div className="position-absolute mt-2 ps-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M10.0003 4.99996V9.99996L13.3337 11.6666M18.3337 9.99996C18.3337 14.6023 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6023 1.66699 9.99996C1.66699 5.39759 5.39795 1.66663 10.0003 1.66663C14.6027 1.66663 18.3337 5.39759 18.3337 9.99996Z"
                                    stroke="#667085"
                                    strokeWidth="1.66667"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                              <select className="form-select rounded h-100 ps-5 fw-bold">
                                <option className="border-0 after">
                                  {' '}
                                  Standard Time (PST) UTC−08:00
                                </option>
                                <option>US</option>
                              </select>
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="Current-details mt-4">
                        <h4>Native place</h4>
                        <div className="basic  pb-4 border-bottom">
                          <a href="#" className="nav-link">
                            Update your native location details
                            here.
                          </a>
                        </div>
                        <div className="row align-items-top pb-4 mt-4">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              Country{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <span className="input-group-btn">
                              <select
                                id="country"
                                value={selectedNativeCountry}
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setFieldValue(
                                    'nativeLocationCountry',
                                    e?.currentTarget?.value,
                                    {
                                      shouldValidate: true,
                                    }
                                  )
                                  //alert(e?.currentTarget?.value)
                                  handleCountryChange(e)
                                }}
                              >
                                {values?.nativeLocationCountry ? (
                                  <option
                                    defaultValue={
                                      values?.nativeLocationCountry
                                    }
                                  >
                                    {
                                      values?.nativeLocationCountry
                                    }
                                  </option>
                                ) : (
                                  <option defaultChecked="">
                                    Select Country{' '}
                                  </option>
                                )}
                                {nativecountries?.map(
                                  (country) => {
                                    return (
                                      country?.countryName !==
                                      'Mexico' && (
                                        <option
                                          key={
                                            country?.countryId
                                          }
                                          value={
                                            country?.countryName
                                          }
                                        >
                                          {country?.countryName}
                                        </option>
                                      )
                                    )
                                  }
                                )}
                              </select>
                              {touched?.nativeLocationCountry &&
                                errors?.nativeLocationCountry && (
                                  <FormHelperText
                                    error
                                    id="helper-text-fre8ProUserId"
                                  >
                                    {
                                      errors?.nativeLocationCountry
                                    }
                                  </FormHelperText>
                                )}
                            </span>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4 mt-1">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              State{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>

                          <div className="col-lg-4">
                            <span className="input-group-btn">
                              <select
                                id="state"
                                value={selectedNativeState}
                                className="form-select"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  setFieldValue(
                                    'nativeLocationState',
                                    e?.currentTarget?.value,
                                    {
                                      shouldValidate: true,
                                    }
                                  )
                                  handleStateChange(e)
                                }}
                              >
                                {values?.nativeLocationState ? (
                                  <option
                                    defaultValue={
                                      values?.nativeLocationState
                                    }
                                  >
                                    {
                                      values?.nativeLocationState
                                    }
                                  </option>
                                ) : (
                                  <option defaultChecked="">
                                    Select State{' '}
                                  </option>
                                )}
                                {/* {countries?.find(c => c.name === selectedCountry)?.states?.map(state => ( */}
                                {nativestates?.map((state) => (
                                  <option
                                    key={state?.stateId}
                                    value={state?.stateName}
                                  >
                                    {state?.stateName}
                                  </option>
                                ))}
                              </select>
                              {touched?.selectedNativeState &&
                                errors?.selectedNativeState && (
                                  <FormHelperText
                                    error
                                    id="helper-text-fre8ProUserId"
                                  >
                                    {
                                      errors?.selectedNativeState
                                    }
                                  </FormHelperText>
                                )}
                            </span>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4 mt-1">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              City{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <span className="input-group-btn">
                              <InputField
                                tag={'select'}
                                values={values}
                                name={'nativeLocationCity'}
                                touched={touched}
                                errors={errors}
                              // handleCountryChange={handleCountryChange}
                              // onChange={(e)=>handleCountryChange(e.target.value)}
                              >
                                {values?.nativeLocationCity ? (
                                  <option
                                    defaultValue={
                                      values?.nativeLocationCity
                                    }
                                  >
                                    {values?.nativeLocationCity}
                                  </option>
                                ) : (
                                  <option defaultChecked="">
                                    Select City{' '}
                                  </option>
                                )}
                                {values?.nativeLocationCountry ===
                                  'Canada'
                                  ? CanadaStates[
                                    values
                                      ?.nativeLocationState
                                  ]?.cities?.map((cites) => (
                                    <option
                                      key={cites}
                                      value={cites}
                                    >
                                      {cites}
                                    </option>
                                  ))
                                  : UsaStates[
                                    values
                                      ?.nativeLocationState
                                  ]?.cities?.map((cites) => (
                                    <option
                                      key={cites}
                                      value={cites}
                                    >
                                      {cites}
                                    </option>
                                  ))}
                              </InputField>
                            </span>
                          </div>
                        </div>

                        <div className="row align-items-top pb-4">
                          <div className="col-lg-4">
                            <lable className="lable-color">
                              ZIP{' '}
                              <span style={{ color: 'red' }}>
                                *
                              </span>
                            </lable>
                          </div>
                          <div className="col-lg-4">
                            <InputField
                              tag={'select'}
                              values={values}
                              name={'nativeLocationZip'}
                              touched={touched}
                              errors={errors}
                            >
                              {values?.nativeLocationZip ? (
                                <option
                                  defaultValue={
                                    values?.nativeLocationZip
                                  }
                                >
                                  {values?.nativeLocationZip}
                                </option>
                              ) : (
                                <option defaultChecked="">
                                  Select Country{' '}
                                </option>
                              )}
                              <option value="C0A">C0A</option>
                              <option value="T5J">T5J</option>
                              <option value="E3A">E3A</option>
                              <option value="E5R">E5R</option>
                              <option value="S3A">S3A</option>
                              <option value="H5E">H5E</option>
                            </InputField>
                          </div>
                        </div>
                        <div className="border-top mb-3 pt-3 d-flex align-item-center justify-content-center gap-3">
                          <button
                            type="button"
                            className="btn cancelBtn py-2 px-5"
                            onClick={() => navigate(-1)}
                          >
                            Cancel
                          </button>
                          <Typography
                            component={Link}
                            className={'btn ms-2 submitBtn py-2 px-5'}
                            to="/alliance/UploadDocuments"
                            color="textSecondary"
                            variant="h6"
                            type='submit'
                            sx={{ textDecoration: 'none' }}
                          >
                            Next
                          </Typography>
                          {/* <button
                            type="submit"
                            className="btn custom-button py-2 px-5"
                          >
                            Next
                          </button> */}
                        </div>
                      </div>
                    </>
                  </Form>
                )}
              </Formik>
            </div>
            {toasts && <Toasts toastsList={toasts} />}
          </div>
        </div>
      </main>
    </>
  )
}

export default PersonalInfoUpdateScreen
